// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"AI-z","carouselContainer":"BI-z"};